<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<br/>
<h1 class="page-header">Identical Connector</h1>
<br/>
@if (permission()) {
    <table class="files-input" [class.hidden]="this.harnessToCountMap.size !== 0">
        <tr>
            <td>
                <app-file-upload-card (filesSelected)="onFileSelected($event, 'harnessZip')"
                                      [header]="harnessUploadHeader" [accept]="harnessUploadAccept"
                                      [subheader]="harnessUploadSubheader"></app-file-upload-card>
            </td>
        </tr>
        <tr>
            <div class="buttons">
                <p-button label="Generate Identical Connectors" icon="pi pi-check" class="gm-btn-primary mr-2"
                          [disabled]="!harnessZip || !permission()"
                          (click)="generateIdenticalConnectors()">
                </p-button>
            </div>
        </tr>
    </table>
}
@if (progress() > 0) {
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
}

<!--
  Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<!--
  Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

@if (harnessToCountMap.size > 0) {
  <div>
    <div>
      <p>Found {{harnessToCountMap.size}} Harnesses: </p>
      <ul>
        @for (entry of harnessToCountMap | keyvalue; track entry) {
          <li>
            <span
              class="clickable-text"
              [class.highlighted]="harnessFilters.includes(entry.key)"
              (click)="applyQuickFilter(entry.key.valueOf())">
              {{entry.key}} ({{entry.value}})
            </span>
          </li>
        }
      </ul>
    </div>
    <div>
      <div>
        {{harnessFilters && harnessFilters.length ? 'Filtering by harness: ' + harnessFilters[0] + (harnessFilters[1] ? ' and ' + harnessFilters[1] : '') : ''}}
      </div>
      <div>
        {{rowData.length || (harnessFilters && harnessFilters.length) ? 'Total Rows: ' + rowData.length : ''}}
      </div>
      <div class="clearFilterButton-container">
        <p-button (click)="downloadReport()" label="Download Report" styleClass="mr-2 mb-2"></p-button>
            <p-button (click)="clearFilters()" label="Clear Grid Filters" class="gm-btn-primary mr-2 mb-2"></p-button>
        <p-button label="Change Files" (click)="harnessToCountMap.clear(); harnessFilters = []; clearFilters();"
        severity="warn" class="mb-2"></p-button>
      </div>
      <ag-grid-angular #gridRef style="width: 100%; height: 500px;" class="ag-theme-balham" [columnDefs]="columnDefs"
      [rowData]="rowDataSignal()" [defaultColDef]="defaultColDef" [pagination]="true"
      (gridReady)="onResultsGridReady($event)"></ag-grid-angular>
    </div>
  </div>
}